var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 45,
    viewBox: "0 0 201 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_3368)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1082 11.0563C71.9144 10.5361 71.7257 10.0465 71.5574 9.59258C71.384 9.13868 71.1902 8.70008 70.9709 8.27678C70.7516 7.85347 70.5017 7.45057 70.2212 7.07317C69.9407 6.69577 69.6041 6.31837 69.2114 5.95117C68.5841 5.36467 67.9415 4.94647 67.2938 4.69657C66.641 4.44667 65.9066 4.32427 65.0804 4.32427C63.8462 4.32427 62.7956 4.56397 61.9388 5.03827C61.082 5.51767 60.2966 6.21127 59.5775 7.11907C58.6442 8.31248 57.9659 9.62828 57.5426 11.0716C57.1193 12.5149 56.9102 14.0296 56.9102 15.6106C56.9102 16.9774 57.0683 18.3136 57.3845 19.6141C57.7007 20.9146 58.2005 22.0672 58.8839 23.0617C59.5673 24.0562 60.4496 24.862 61.5359 25.4689C62.6222 26.0758 63.9431 26.3818 65.5088 26.3818C66.6155 26.3818 67.6916 26.1931 68.732 25.8106C69.7724 25.4332 70.6088 24.7957 71.2361 23.9083C71.8634 23.0209 72.3326 21.7816 72.6335 20.2006L72.9905 20.2669C72.8171 21.8275 72.3989 23.1484 71.7359 24.2194C71.0729 25.2955 70.0376 26.1115 68.63 26.6776C68.0027 26.9377 67.3244 27.1315 66.5951 27.2641C65.8658 27.3967 65.1263 27.4579 64.3664 27.4579C63.6065 27.4579 62.8517 27.3967 62.102 27.2794C61.3523 27.1621 60.6434 26.9938 59.9702 26.7745C58.7972 26.3818 57.7721 25.8412 56.8949 25.1476C56.0177 24.454 55.2782 23.6329 54.6815 22.6894C54.0848 21.7459 53.6411 20.7106 53.3453 19.5835C53.0546 18.4564 52.9067 17.2732 52.9067 16.0339C52.9067 15.121 52.9883 14.2081 53.1515 13.285C53.3147 12.3619 53.5697 11.4847 53.9165 10.6483C54.2633 9.81188 54.6917 9.02648 55.2017 8.28698C55.7117 7.54747 56.3237 6.89977 57.0428 6.33367C58.1036 5.50747 59.3276 4.86997 60.7046 4.41607C62.0816 3.96217 63.4535 3.73267 64.8203 3.73267C65.8607 3.73267 66.7685 3.83977 67.5386 4.05907C68.3087 4.27837 68.9768 4.48237 69.5378 4.67617C70.1039 4.86997 70.568 5.00767 70.9352 5.08417C71.3024 5.16067 71.588 5.05867 71.7818 4.77307C71.8685 4.68637 71.9654 4.50277 72.0725 4.22227L72.1031 4.25287V11.0563H72.1082Z",
    fill: "#343538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8957 3.73779V3.76839C91.0287 3.81429 90.3458 3.96219 89.8461 4.22229C89.3457 4.48239 88.9688 4.83939 88.7082 5.29839C88.4484 5.75739 88.285 6.29289 88.2189 6.90999C88.1528 7.52709 88.1217 8.21557 88.1217 8.97547V22.2202C88.1217 22.9801 88.1528 23.6686 88.2189 24.2857C88.285 24.9028 88.4484 25.4434 88.7082 25.8973C88.9688 26.3512 89.3457 26.7133 89.8461 26.9734C90.3458 27.2335 91.0191 27.3865 91.8654 27.4273H80.635C81.4614 27.3865 82.1802 27.1825 82.7978 26.8255C83.4145 26.4685 83.8329 25.8463 84.052 24.9538C84.0927 24.6478 84.1389 24.2755 84.1851 23.8318C84.2258 23.3881 84.2513 22.8526 84.2513 22.2202V8.97547C84.2513 8.08807 84.205 7.29249 84.1182 6.59889C84.0321 5.90529 83.7516 5.30859 83.2719 4.80879C82.9045 4.41609 82.4918 4.15599 82.0328 4.02849C81.5785 3.89589 81.0582 3.81429 80.4717 3.76839V3.73779H91.8957Z",
    fill: "#343538"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.522 4.28859C108.002 4.28859 107.441 4.29879 106.845 4.31919C106.248 4.33959 105.656 4.38039 105.069 4.43139C104.483 4.48749 103.917 4.56399 103.377 4.66089C102.836 4.75779 102.366 4.88529 101.979 5.03319C100.938 5.46669 100.164 6.17049 99.6538 7.14969C99.1438 8.12377 98.7708 9.19987 98.5318 10.3729H98.4648V3.73779H122.613V10.378H122.583C122.303 8.96527 121.89 7.85349 121.349 7.04259C120.808 6.23169 120.114 5.61969 119.283 5.22189C118.447 4.81899 117.462 4.56399 116.32 4.45689C115.183 4.34979 113.872 4.29369 112.398 4.29369V22.1539C112.398 22.9342 112.434 23.638 112.511 24.2704C112.587 24.8977 112.755 25.4383 113.016 25.882C113.276 26.3257 113.653 26.6776 114.153 26.9377C114.653 27.1978 115.326 27.3508 116.172 27.3916V27.4222H104.748V27.3916C105.615 27.3508 106.299 27.1978 106.799 26.9377C107.298 26.6776 107.676 26.3257 107.936 25.882C108.196 25.4383 108.359 24.9028 108.426 24.2704C108.492 23.638 108.522 22.9342 108.522 22.1539V4.28859Z",
    fill: "#343538"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.77 22.1896C136.77 22.9699 136.806 23.6737 136.882 24.3061C136.959 24.9334 137.127 25.474 137.388 25.9177C137.647 26.3614 138.025 26.7133 138.525 26.9734C139.024 27.2335 139.708 27.3865 140.575 27.4273V27.4579H129.151V27.4273C130.018 27.3865 130.707 27.2284 131.217 26.953C131.727 26.6827 132.099 26.3206 132.339 25.8616C132.578 25.4077 132.731 24.8671 132.792 24.25C132.859 23.6329 132.889 22.9444 132.889 22.1845V8.97547C132.889 8.19517 132.859 7.49139 132.792 6.85899C132.726 6.22659 132.563 5.69109 132.303 5.24739C132.043 4.80369 131.66 4.45179 131.166 4.19169C130.666 3.93159 129.993 3.77859 129.146 3.73779H142.227C143.375 3.73779 144.405 3.90099 145.318 4.22739C146.231 4.55379 147.031 5.23719 147.725 6.27759C148.204 6.97119 148.51 7.73619 148.653 8.57257C148.796 9.40897 148.755 10.2301 148.541 11.0461C148.322 11.8621 147.939 12.6067 147.384 13.2901C146.827 13.9735 146.088 14.4988 145.155 14.866C144.895 14.9731 144.589 15.0853 144.242 15.1924C143.895 15.2995 143.502 15.4015 143.069 15.4831C143.589 15.7024 144.007 15.9217 144.324 16.1512C144.64 16.3807 144.905 16.6408 145.119 16.9315C145.333 17.2222 145.537 17.5639 145.721 17.9566C145.905 18.3493 146.129 18.8134 146.389 19.354C146.67 19.9405 146.98 20.578 147.317 21.2716C147.654 21.9652 147.99 22.6384 148.327 23.2912C148.663 23.944 148.995 24.5458 149.322 25.0966C149.648 25.6474 149.928 26.0656 150.168 26.3512C150.474 26.7184 150.765 26.9785 151.045 27.1315C151.326 27.2845 151.708 27.3814 152.182 27.4222V27.4528H146.129C145.889 26.953 145.629 26.3716 145.348 25.7137C145.068 25.0507 144.762 24.3622 144.436 23.6482C144.109 22.9342 143.767 22.2049 143.41 21.4654C143.053 20.7259 142.681 20.0374 142.304 19.3999C141.921 18.7624 141.549 18.1861 141.182 17.6761C140.815 17.1661 140.442 16.7836 140.075 16.5184C139.575 16.1512 139.055 15.9472 138.514 15.9166C137.974 15.886 137.388 15.8656 136.755 15.8656V22.1794L136.77 22.1896ZM136.77 15.4525H138.51C139.04 15.4525 139.54 15.4168 140.009 15.3403C140.473 15.2638 140.917 15.1414 141.325 14.968C141.738 14.7946 142.125 14.5345 142.498 14.1877C143.497 13.234 144.099 12.1069 144.303 10.8013C144.507 9.50077 144.354 8.25127 143.834 7.05789C143.487 6.27759 143.074 5.68599 142.594 5.28309C142.115 4.88019 141.58 4.59969 140.983 4.43649C140.386 4.27329 139.734 4.18659 139.03 4.17639C138.326 4.16619 137.571 4.16109 136.765 4.16109V15.4525H136.77Z",
    fill: "#343538"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 3.73779V3.76839C168.61 3.81429 167.926 3.96219 167.426 4.22229C166.927 4.48239 166.549 4.83939 166.289 5.29839C166.029 5.75229 165.866 6.29289 165.799 6.90999C165.733 7.52709 165.703 8.21557 165.703 8.97547V22.2202C165.703 22.9801 165.733 23.6686 165.799 24.2857C165.866 24.9028 166.029 25.4434 166.289 25.8973C166.549 26.3512 166.927 26.7133 167.426 26.9734C167.926 27.2335 168.599 27.3865 169.446 27.4273H158.216C159.042 27.3865 159.761 27.1825 160.378 26.8255C160.996 26.4685 161.413 25.8463 161.633 24.9538C161.674 24.6478 161.719 24.2755 161.765 23.8318C161.806 23.3881 161.832 22.8526 161.832 22.2202V8.97547C161.832 8.08807 161.786 7.29249 161.699 6.59889C161.612 5.90529 161.332 5.30859 160.852 4.80879C160.486 4.41609 160.072 4.15599 159.613 4.02849C159.16 3.89589 158.639 3.81429 158.053 3.76839V3.73779H169.477Z",
    fill: "#343538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.465 6.59889V22.2202C178.465 23.0005 178.5 23.6992 178.577 24.3214C178.653 24.9385 178.816 25.4689 179.077 25.9177C179.337 26.3614 179.709 26.7133 180.204 26.9734C180.699 27.2335 181.366 27.3865 182.203 27.4273V27.4579H173.936V27.4273C174.783 27.3865 175.456 27.2335 175.956 26.9734C176.455 26.7133 176.833 26.3614 177.093 25.9177C177.353 25.474 177.521 24.9436 177.598 24.3214C177.674 23.7043 177.71 23.0056 177.71 22.2202V8.97547C177.71 8.19517 177.674 7.49139 177.598 6.85899C177.521 6.23169 177.353 5.69109 177.093 5.24739C176.833 4.80369 176.45 4.45689 175.956 4.20699C175.456 3.95709 174.783 3.81429 173.936 3.76839V3.73779H181.162L195.387 21.9652V8.97547C195.387 8.19517 195.356 7.49649 195.289 6.87429C195.223 6.25209 195.06 5.72679 194.8 5.27799C194.54 4.83429 194.157 4.48239 193.663 4.22229C193.163 3.96219 192.49 3.80919 191.643 3.76839V3.73779H199.91V3.76839C198.997 3.76839 198.222 3.97749 197.584 4.38549C196.942 4.79859 196.529 5.42589 196.33 6.27249C196.197 6.85899 196.136 7.75659 196.136 8.97547V27.463H195.03L178.459 6.59889H178.465Z",
    fill: "#343538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9565 33.073H82.7112L85.1488 41.5441L87.7753 33.073H88.6216L91.264 41.5441L93.6865 33.073H94.4412L91.7071 42.5029H90.8457L88.204 34.0012L85.552 42.5029H84.6898L81.9565 33.073Z",
    fill: "#343538"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.992 41.8297V42.5029H99.5601V33.073H104.921V33.7462H100.274V37.408H104.584V38.0812H100.274V41.8246H104.992V41.8297Z",
    fill: "#343538"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.408 41.8297V42.5029H110.247V33.073H110.961V41.8297H115.408Z",
    fill: "#343538"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 41.8297V42.5029H120.389V33.073H121.103V41.8297H125.55Z",
    fill: "#343538"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M137.449 33.073V42.5029H136.816L131.252 34.3939V42.5029H130.538V33.073H131.16L136.74 41.182V33.073H137.454H137.449Z",
    fill: "#343538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.724 41.8297V42.5029H143.297V33.073H148.658V33.7462H144.011V37.408H148.321V38.0812H144.011V41.8246H148.724V41.8297Z",
    fill: "#343538"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.412 40.4325L154.034 40.0704C154.356 41.2026 155.314 41.9676 156.864 41.9676C158.415 41.9676 159.236 41.1618 159.236 40.0806C159.236 38.9484 158.241 38.52 156.798 38.061C155.223 37.551 153.81 37.1022 153.81 35.46C153.81 33.9096 155.064 32.9253 156.666 32.9253C158.267 32.9253 159.236 33.8127 159.695 34.9041L159.088 35.2407C158.736 34.3941 158.012 33.6087 156.666 33.6087C155.319 33.6087 154.539 34.3788 154.539 35.4294C154.539 36.5616 155.498 36.9135 156.844 37.3572C158.517 37.908 159.97 38.4333 159.97 40.0653C159.97 41.6973 158.746 42.651 156.875 42.651C155.11 42.651 153.855 41.7636 153.427 40.4274L153.412 40.4325Z",
    fill: "#343538"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164.31 40.4325L164.932 40.0704C165.254 41.2026 166.213 41.9676 167.763 41.9676C169.314 41.9676 170.134 41.1618 170.134 40.0806C170.134 38.9484 169.14 38.52 167.697 38.061C166.121 37.551 164.708 37.1022 164.708 35.46C164.708 33.9096 165.963 32.9253 167.564 32.9253C169.165 32.9253 170.134 33.8127 170.593 34.9041L169.987 35.2407C169.635 34.3941 168.91 33.6087 167.564 33.6087C166.218 33.6087 165.438 34.3788 165.438 35.4294C165.438 36.5616 166.396 36.9135 167.743 37.3572C169.416 37.908 170.869 38.4333 170.869 40.0653C170.869 41.6973 169.645 42.651 167.773 42.651C166.009 42.651 164.754 41.7636 164.326 40.4274L164.31 40.4325Z",
    fill: "#343538"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3109 44.4661C11.402 44.4661 2.52295 35.5921 2.52295 24.6781C2.52295 13.7641 11.3969 4.89014 22.3109 4.89014C33.2249 4.89014 42.0989 13.7641 42.0989 24.6781C42.0989 35.5921 33.2249 44.4661 22.3109 44.4661ZM22.3109 5.24204C11.5907 5.24204 2.87485 13.963 2.87485 24.6781C2.87485 35.3932 11.5958 44.1142 22.3109 44.1142C33.026 44.1142 41.747 35.3932 41.747 24.6781C41.747 13.963 33.026 5.24204 22.3109 5.24204Z",
    fill: "#343538"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_3368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 41,
    height: 41
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3119 44.4661C11.403 44.4661 2.52393 35.5921 2.52393 24.6781C2.52393 13.7641 11.3979 4.89014 22.3119 4.89014C33.2259 4.89014 42.0999 13.7641 42.0999 24.6781C42.0999 35.5921 33.2259 44.4661 22.3119 44.4661ZM22.3119 5.24204C11.5917 5.24204 2.87583 13.963 2.87583 24.6781C2.87583 35.3932 11.5968 44.1142 22.3119 44.1142C33.027 44.1142 41.748 35.3932 41.748 24.6781C41.748 13.963 33.027 5.24204 22.3119 5.24204Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_3368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32841 5.24194H2.87451V44.1141H3.32841V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2631 5.24194H3.32471V44.1141H4.2631V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20598 5.24194H4.26758V44.1141H5.20598V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14397 5.24194H5.20557V44.1141H6.14397V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08781 5.24194H6.14941V44.1141H7.08781V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02627 5.24194H7.08789V44.1141H8.02627V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97014 5.24194H8.03174V44.1141H8.97014V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90959 5.24194H8.97119V44.1141H9.90959V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8466 5.24194H9.9082V44.1141H10.8466V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7905 5.24194H10.8521V44.1141H11.7905V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.728 5.24194H11.7896V44.1141H12.728V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6723 5.24194H12.7339V44.1141H13.6723V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6108 5.24194H13.6724V44.1141H14.6108V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5546 5.24194H14.6162V44.1141H15.5546V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4931 5.24194H15.5547V44.1141H16.4931V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4306 5.24194H16.4922V44.1141H17.4306V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3749 5.24194H17.4365V44.1141H18.3749V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3124 5.24194H18.374V44.1141H19.3124V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2563 5.24194H19.3179V44.1141H20.2563V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1947 5.24194H20.2563V44.1141H21.1947V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1371 5.24194H21.1987V44.1141H22.1371V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0776 5.24194H22.1392V44.1141H23.0776V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0151 5.24194H23.0767V44.1141H24.0151V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9589 5.24194H24.0205V44.1141H24.9589V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8969 5.24194H24.9585V44.1141H25.8969V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8398 5.24194H25.9014V44.1141H26.8398V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7792 5.24194H26.8408V44.1141H27.7792V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7216 5.24194H27.7832V44.1141H28.7216V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6601 5.24194H28.7217V44.1141H29.6601V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5995 5.24194H29.6611V44.1141H30.5995V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5424 5.24194H30.604V44.1141H31.5424V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4804 5.24194H31.542V44.1141H32.4804V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4242 5.24194H32.4858V44.1141H33.4242V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3637 5.24194H33.4253V44.1141H34.3637V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3061 5.24194H34.3677V44.1141H35.3061V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2446 5.24194H35.3062V44.1141H36.2446V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1821 5.24194H36.2437V44.1141H37.1821V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1269 5.24194H37.1885V44.1141H38.1269V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0649 5.24194H38.1265V44.1141H39.0649V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0087 5.24194H39.0703V44.1141H40.0087V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9472 5.24194H40.0088V44.1141H40.9472V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7477 5.24194H40.9521V44.1141H41.7477V5.24194Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32463 4.89014H2.52393V44.461H3.32463V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2631 4.89014H3.32471V44.461H4.2631V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20598 4.89014H4.26758V44.461H5.20598V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14397 4.89014H5.20557V44.461H6.14397V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08781 4.89014H6.14941V44.461H7.08781V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02627 4.89014H7.08789V44.461H8.02627V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97014 4.89014H8.03174V44.461H8.97014V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90959 4.89014H8.97119V44.461H9.90959V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8466 4.89014H9.9082V44.461H10.8466V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7905 4.89014H10.8521V44.461H11.7905V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.728 4.89014H11.7896V44.461H12.728V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6723 4.89014H12.7339V44.461H13.6723V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6108 4.89014H13.6724V44.461H14.6108V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5546 4.89014H14.6162V44.461H15.5546V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4931 4.89014H15.5547V44.461H16.4931V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4306 4.89014H16.4922V44.461H17.4306V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3749 4.89014H17.4365V44.461H18.3749V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3124 4.89014H18.374V44.461H19.3124V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2563 4.89014H19.3179V44.461H20.2563V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1947 4.89014H20.2563V44.461H21.1947V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1371 4.89014H21.1987V44.461H22.1371V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0776 4.89014H22.1392V44.461H23.0776V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0151 4.89014H23.0767V44.461H24.0151V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9589 4.89014H24.0205V44.461H24.9589V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8969 4.89014H24.9585V44.461H25.8969V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8398 4.89014H25.9014V44.461H26.8398V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7792 4.89014H26.8408V44.461H27.7792V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7216 4.89014H27.7832V44.461H28.7216V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6601 4.89014H28.7217V44.461H29.6601V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5995 4.89014H29.6611V44.461H30.5995V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5424 4.89014H30.604V44.461H31.5424V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4804 4.89014H31.542V44.461H32.4804V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4242 4.89014H32.4858V44.461H33.4242V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3637 4.89014H33.4253V44.461H34.3637V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3061 4.89014H34.3677V44.461H35.3061V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2446 4.89014H35.3062V44.461H36.2446V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1821 4.89014H36.2437V44.461H37.1821V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1269 4.89014H37.1885V44.461H38.1269V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0649 4.89014H38.1265V44.461H39.0649V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0087 4.89014H39.0703V44.461H40.0087V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9472 4.89014H40.0088V44.461H40.9472V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8905 4.89014H40.9521V44.461H41.8905V4.89014Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0946 4.89014H41.8906V44.461H42.0946V4.89014Z",
    fill: "#343538"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.254 44.5121C9.98338 44.5121 -0.00244141 34.5263 -0.00244141 22.2557C-0.00244141 9.98505 9.98338 -0.000732422 22.254 -0.000732422C34.5246 -0.000732422 44.5104 9.98505 44.5104 22.2557C44.5104 34.5263 34.5246 44.5121 22.254 44.5121ZM22.254 0.351167C10.1721 0.351167 0.349458 10.1737 0.349458 22.2557C0.349458 34.3376 10.1772 44.1602 22.254 44.1602C34.3308 44.1602 44.1585 34.3325 44.1585 22.2557C44.1585 10.1789 34.3308 0.351167 22.254 0.351167Z",
    fill: "#343538"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_43_3368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 46,
    height: 46
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2525 44.5121C9.98188 44.5121 -0.00390625 34.5263 -0.00390625 22.2557C-0.00390625 9.98505 9.98188 -0.000732422 22.2525 -0.000732422C34.5231 -0.000732422 44.5089 9.98505 44.5089 22.2557C44.5089 34.5263 34.5231 44.5121 22.2525 44.5121ZM22.2525 0.351167C10.1706 0.351167 0.347994 10.1737 0.347994 22.2557C0.347994 34.3376 10.1757 44.1602 22.2525 44.1602C34.3293 44.1602 44.157 34.3325 44.157 22.2557C44.157 10.1789 34.3293 0.351167 22.2525 0.351167Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_43_3368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.505268 0.351074H0.347168V44.1652H0.505268V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44035 0.351074H0.501953V44.1652H1.44035V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38274 0.351074H1.44434V44.1652H2.38274V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32121 0.351074H2.38281V44.1652H3.32121V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2592 0.351074H3.3208V44.1652H4.2592V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20305 0.351074H4.26465V44.1652H5.20305V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14152 0.351074H5.20312V44.1652H6.14152V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08537 0.351074H6.14697V44.1652H7.08537V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02385 0.351074H7.08545V44.1652H8.02385V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96721 0.351074H8.02881V44.1652H8.96721V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90569 0.351074H8.96729V44.1652H9.90569V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8432 0.351074H9.90479V44.1652H10.8432V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.787 0.351074H10.8486V44.1652H11.787V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.726 0.351074H11.7876V44.1652H12.726V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6698 0.351074H12.7314V44.1652H13.6698V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 0.351074H13.6699V44.1652H14.6083V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5507 0.351074H14.6123V44.1652H15.5507V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4902 0.351074H15.5518V44.1652H16.4902V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4277 0.351074H16.4893V44.1652H17.4277V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.371 0.351074H17.4326V44.1652H18.371V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.31 0.351074H18.3716V44.1652H19.31V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2538 0.351074H19.3154V44.1652H20.2538V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1928 0.351074H20.2544V44.1652H21.1928V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1352 0.351074H21.1968V44.1652H22.1352V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0741 0.351074H22.1357V44.1652H23.0741V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 0.351074H23.0728V44.1652H24.0112V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.955 0.351074H24.0166V44.1652H24.955V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8945 0.351074H24.9561V44.1652H25.8945V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8368 0.351074H25.8984V44.1652H26.8368V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7768 0.351074H26.8384V44.1652H27.7768V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7192 0.351074H27.7808V44.1652H28.7192V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6576 0.351074H28.7192V44.1652H29.6576V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5956 0.351074H29.6572V44.1652H30.5956V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5395 0.351074H30.6011V44.1652H31.5395V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4779 0.351074H31.5396V44.1652H32.4779V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4213 0.351074H32.4829V44.1652H33.4213V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3598 0.351074H33.4214V44.1652H34.3598V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3036 0.351074H34.3652V44.1652H35.3036V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2421 0.351074H35.3037V44.1652H36.2421V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1801 0.351074H36.2417V44.1652H37.1801V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1239 0.351074H37.1855V44.1652H38.1239V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0624 0.351074H38.124V44.1652H39.0624V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0048 0.351074H39.0664V44.1652H40.0048V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9443 0.351074H40.0059V44.1652H40.9443V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8881 0.351074H40.9497V44.1652H41.8881V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8266 0.351074H41.8882V44.1652H42.8266V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7641 0.351074H42.8257V44.1652H43.7641V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1571 0.351074H43.7695V44.1652H44.1571V0.351074Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.500994 -0.000732422H-0.00390625V44.5121H0.500994V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44035 -0.000732422H0.501953V44.5121H1.44035V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38274 -0.000732422H1.44434V44.5121H2.38274V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32121 -0.000732422H2.38281V44.5121H3.32121V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2592 -0.000732422H3.3208V44.5121H4.2592V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20305 -0.000732422H4.26465V44.5121H5.20305V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14152 -0.000732422H5.20312V44.5121H6.14152V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08537 -0.000732422H6.14697V44.5121H7.08537V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02385 -0.000732422H7.08545V44.5121H8.02385V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96721 -0.000732422H8.02881V44.5121H8.96721V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90569 -0.000732422H8.96729V44.5121H9.90569V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8432 -0.000732422H9.90479V44.5121H10.8432V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.787 -0.000732422H10.8486V44.5121H11.787V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.726 -0.000732422H11.7876V44.5121H12.726V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6698 -0.000732422H12.7314V44.5121H13.6698V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 -0.000732422H13.6699V44.5121H14.6083V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5507 -0.000732422H14.6123V44.5121H15.5507V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4902 -0.000732422H15.5518V44.5121H16.4902V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4277 -0.000732422H16.4893V44.5121H17.4277V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.371 -0.000732422H17.4326V44.5121H18.371V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.31 -0.000732422H18.3716V44.5121H19.31V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2538 -0.000732422H19.3154V44.5121H20.2538V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1928 -0.000732422H20.2544V44.5121H21.1928V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1352 -0.000732422H21.1968V44.5121H22.1352V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0741 -0.000732422H22.1357V44.5121H23.0741V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 -0.000732422H23.0728V44.5121H24.0112V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.955 -0.000732422H24.0166V44.5121H24.955V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8945 -0.000732422H24.9561V44.5121H25.8945V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8368 -0.000732422H25.8984V44.5121H26.8368V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7768 -0.000732422H26.8384V44.5121H27.7768V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7192 -0.000732422H27.7808V44.5121H28.7192V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6576 -0.000732422H28.7192V44.5121H29.6576V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5956 -0.000732422H29.6572V44.5121H30.5956V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5395 -0.000732422H30.6011V44.5121H31.5395V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4779 -0.000732422H31.5396V44.5121H32.4779V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4213 -0.000732422H32.4829V44.5121H33.4213V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3598 -0.000732422H33.4214V44.5121H34.3598V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3036 -0.000732422H34.3652V44.5121H35.3036V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2421 -0.000732422H35.3037V44.5121H36.2421V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1801 -0.000732422H36.2417V44.5121H37.1801V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1239 -0.000732422H37.1855V44.5121H38.1239V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0624 -0.000732422H38.124V44.5121H39.0624V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0048 -0.000732422H39.0664V44.5121H40.0048V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9443 -0.000732422H40.0059V44.5121H40.9443V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8881 -0.000732422H40.9497V44.5121H41.8881V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8266 -0.000732422H41.8882V44.5121H42.8266V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7641 -0.000732422H42.8257V44.5121H43.7641V-0.000732422Z",
    fill: "#343538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.509 -0.000732422H43.7695V44.5121H44.509V-0.000732422Z",
    fill: "#343538"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9112 18.8799C14.5126 24.9591 17.2054 30.6762 20.8315 35.7864C21.3007 36.4545 21.8005 37.1175 22.3054 37.7652V39.438L22.2952 39.4278C21.8311 39.1728 3.52718 28.8249 12.9061 18.8799H12.9112Z",
    fill: "#343538"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7847 35.7864C27.4108 30.6762 30.1036 24.9591 31.705 18.8799C41.0839 28.8249 22.78 39.1728 22.3159 39.4278L22.3057 39.438V37.7652C22.8106 37.1124 23.3104 36.4545 23.7796 35.7864H23.7847Z",
    fill: "#343538"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.922 41.2381C29.9812 37.9027 34.3672 33.634 37.8505 28.6462C39.5029 42.5335 22.3057 44.293 22.3057 44.293V42.8599C23.1982 42.355 24.0703 41.8144 24.922 41.2381Z",
    fill: "#343538"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76569 28.6411C10.249 33.6289 14.635 37.9027 19.6942 41.233C20.5408 41.8093 21.418 42.3448 22.3105 42.8548V44.2879C22.3105 44.2879 5.11329 42.5284 6.76569 28.6411Z",
    fill: "#343538"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3103 11.5154V33.4403C22.2593 33.3791 12.2378 20.8535 22.3103 11.5154Z",
    fill: "#343538"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.311 33.4403V11.5154C32.3835 20.8484 22.362 33.374 22.311 33.4403Z",
    fill: "#343538"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3118 0.300293V11.4132C22.2761 11.3826 15.1616 5.03309 22.3118 0.300293Z",
    fill: "#343538"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.311 11.4132V0.300293C29.4612 5.03309 22.3467 11.3826 22.311 11.4132Z",
    fill: "#343538"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_43_3368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 45
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.91 0H0V44.5128H199.91V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_43_3368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_3368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.016,
    height: 44.625,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2c4c4aeb8569ab25c2371f1b5738f80.svg";
export { ForwardRef as ReactComponent };